const Page404 = () => import('@/views/public/404.vue')
const MarketplaceClass = () => import('@/views/public/marketplace/class/Index.vue')
const MarketplaceClassDetail = () => import('@/views/public/marketplace/class/Detail.vue')
const MarketplaceLibrary = () => import('@/views/public/marketplace/library/Index.vue')
const MarketplaceLibraryDetail = () => import('@/views/public/marketplace/library/Detail.vue')
const Profil = () => import('@/views/public/profil/Index.vue')
const AboutUs = () => import('@/views/public/AboutUs.vue')
const Help = () => import('@/views/public/Help.vue')
const Faq = () => import('@/views/public/Faq.vue')
const Privacy = () => import('@/views/public/Privacy.vue')
const TermsConditions = () => import('@/views/public/TermsConditions.vue')

const routes = [
  {
    path: '/404',
    name: '404',
    component: Page404,
    meta: {
      title: '404'
    }
  },
  {
    path: '/marketplace/class',
    name: 'class',
    component: MarketplaceClass,
    meta: {
      title: 'Marketplace'
    }
  },
  {
    path: '/profil',
    name: 'profil',
    component: Profil,
    meta: {
      title: 'Profil'
    }
  },
  {
    path: '/marketplace/class/:id',
    name: 'class detail',
    component: MarketplaceClassDetail,
    meta: {
      title: 'Detail'
    }
  },
  {
    path: '/marketplace/library',
    name: 'library',
    component: MarketplaceLibrary,
    meta: {
      title: 'Library'
    }
  },
  {
    path: '/marketplace/library/:id',
    name: 'library detail',
    component: MarketplaceLibraryDetail,
    meta: {
      title: 'Detail Library'
    }
  },
  {
    path: "/aboutus",
    name: "AboutUs",
    component: AboutUs,
    meta: {
      title: "Tentang Kami"
    }
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
    meta: {
      title: "Pusat Bantuan"
    }
  },
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
    meta: {
      title: "Frequently Asked Question"
    }
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {
      title: "Kebijakan Privasi"
    }
  },
  {
    path: "/terms-conditions",
    name: "Terms Conditions",
    component: TermsConditions,
    meta: {
      title: "Syarat Ketentuan"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: true,
    title: route.meta.title 
  }
  return { ...route, meta }
})